import { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';
import { mapBy, readOnly } from '@ember/object/computed';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import VisibilityState from '@square/dashboard-items-data/models/visibility-state';
import { ModifierToggleOverrideType } from '@square/dashboard-items-data/utils/modifier-constants';

// Creates an ItemItemModifierListMembership model object that will be defined to use Cogs API or new Merchant Catalog API
// depending upon how the user's merchant catalog feature flag is set
export default ItemsV3Base.extend({
  item: belongsTo('item', {
    async: false
  }),
  modifierList: belongsTo('item-modifier-list', {
    async: false
  }),
  visibility: attr('enum', {
    enumClass: VisibilityState,
    defaultValue: VisibilityState.PUBLIC
  }),
  itemModifierOptionOverrides: fragmentArray('item-modifier-option-override'),
  minSelectedModifiers: attr('number', {
    defaultValue: -1
  }),
  maxSelectedModifiers: attr('number', {
    defaultValue: -1
  }),
  enabled: attr('boolean', {
    defaultValue: false
  }),
  hiddenFromCustomer: attr('boolean', {
    defaultValue: false
  }),
  // being deprecated
  hiddenFromCustomerOverride: attr('enum', {
    enumClass: ModifierToggleOverrideType,
    defaultValue: ModifierToggleOverrideType.NOT_SET
  }),
  isConversationalOverride: attr('enum', {
    enumClass: ModifierToggleOverrideType,
    defaultValue: ModifierToggleOverrideType.NOT_SET
  }),
  allowQuantitiesOverride: attr('enum', {
    enumClass: ModifierToggleOverrideType,
    defaultValue: ModifierToggleOverrideType.NOT_SET
  }),
  ordinal: attr('number'),
  modifierListSubunitTokens: readOnly('modifierList.subunitTokens'),
  modifierListName: readOnly('modifierList.name'),
  modifierListFormattedName: readOnly('modifierList.modifierName'),
  modifierListType: readOnly('modifierList.modifierType'),
  actualItemModifierOptionNames: mapBy('modifierList.actualItemModifierOptions', 'name'),
  itemModifierOptionOverrideMap: computed('itemModifierOptionOverrides.[]', function () {
    const overrideMap = {};
    this.itemModifierOptionOverrides.forEach(override => {
      overrideMap[override.get('itemModifierOption.id')] = override;
    });
    return overrideMap;
  }),
  effectiveItemModifierOptionOverrides: computed('modifierList.itemModifierOptions.[]', 'itemModifierOptionOverrideMap', 'store', function () {
    const overrideMap = this.itemModifierOptionOverrideMap;
    return this.modifierList?.itemModifierOptions.sortBy('ordinal').map(modifier => {
      if (overrideMap[modifier.get('id')]) {
        return overrideMap[modifier.get('id')];
      } else {
        return this.store.createFragment('item-modifier-option-override', {
          itemModifierOptionId: modifier.get('id'),
          onByDefault: false,
          hiddenOnline: false
        });
      }
    });
  }),
  hasModifierQuantitiesEnabled: computed('allowQuantitiesOverride', 'modifierList.allowQuantities', 'modifierListType', function () {
    // Whether an item level override for allowing quantities exists
    const hasItemLevelModifierQuantitiesOverride = this.allowQuantitiesOverride !== undefined && this.allowQuantitiesOverride !== ModifierToggleOverrideType.NOT_SET;
    if (hasItemLevelModifierQuantitiesOverride) {
      return this.allowQuantitiesOverride === ModifierToggleOverrideType.YES;
    }
    return this.modifierList?.allowQuantities;
  })
}).reopenClass({
  _modelNameForMigration: 'item-item-modifier-list-membership',
  catalogType() {
    return 'ITEM_ITEM_MODIFIER_LIST_MEMBERSHIP';
  }
});